<template>
  <div class="askyou">
    <van-nav-bar
      title="请假"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div>
      <van-tabs v-model="active" title-active-color="#27B59C" color="#27B59C">
        <van-tab title="请假申请">
          <!-- 请假申请 -->
          <do-leave @toHistoryPage="setActive" />
        </van-tab>
        <van-tab title="请假历史">
          <leave-history-list />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import DoLeave from "../leave/children/DoLeave";
import LeaveHistoryList from "./children/LeaveHistoryList.vue";

export default {
  components: {
    DoLeave,
    LeaveHistoryList,
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    onClickLeft() {
      //   Toast("返回");
      //   console.log("返回");
      this.$router.push({ path: "/foodsInfo" });
    },
    onClickRight() {
      Toast("按钮");
    },
    setActive() {
      console.log("setActive");
      this.active = 1;
    },
  },
};
</script>

<style scoped>
@import "../../styles/forward.css";
</style>
